import React from 'react';
import { COLORS, SHADOW } from '../../theme';

export default function Card({ children, style, ...props }) {
  return (
    <div
      {...props}
      style={{
        background: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        borderRadius: 16,
        padding: 16,
        boxShadow: SHADOW.card,
        ...style
      }}
    >
      {children}
    </div>
  );
}
